module.exports = "<div class=gmc-select><input class=gmc-form-control ng-model=$ctrl.value ng-focus=$ctrl.onFocus() ng-readonly=!$ctrl.filter ng-keyup=$ctrl.onKeyUp($event) placeholder={{::$ctrl.placeholder}}> <span class=gmc-select__toggler ng-click=$ctrl.toggle()><i class=\"material-icons icon\" ng-class=\"{active: $ctrl.isActive}\">arrow_drop_down</i></span><div class=gmc-select__container ng-show=$ctrl.isActive><div class=gmc-select__results ng-style=\"{'max-height': $ctrl.maxHeight + 'px'}\" ng-transclude></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-select-2/gmc-select2.component.html
// module id = 849
// module chunks = 31